window.LoginAppGlobal = {
  turnstileLoaded: false,

  turnstileReadyCallback: null,
  onTurnstileReady: cn => {
    if (window.LoginAppGlobal.turnstileLoaded) {
      if (typeof cn === "function") {
        cn();
      }
      return;
    }

    window.LoginAppGlobal.turnstileReadyCallback = cn;
  }
};

/**
 * App should react to turnstile load, because it sometimes can be loaded after
 * or sometimes before the app, so we need to react properly to it
 */
window.onTurnstileLoad = () => {
  window.LoginAppGlobal.turnstileLoaded = true;

  if (typeof window.LoginAppGlobal.turnstileReadyCallback === "function") {
    window.LoginAppGlobal.turnstileReadyCallback();
  }
};
